import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { PgProviderRouteContainer } from '../../containers/payment/PgProviderRouteContainer';
import { PAYMENT_PAGE_NAME } from '../../constants/service/app/paymentConstants';

/**
 * 결제 PG 라우팅 페이지.
 *
 * 결제수단·계정타입·금액 조건에 따라 어느 PG 사로 보낼지를 운영이 직접 바꾼다.
 * 규칙이 없으면 코드 기본값으로 동작하므로, 규칙을 지우는 것이 곧 롤백이다.
 */
const PgProviderRoute = (): React.JSX.Element => {
  return (
    <PageTemplate pageName={PAYMENT_PAGE_NAME.PG_ROUTE}>
      <PgProviderRouteContainer />
    </PageTemplate>
  );
};

export default PgProviderRoute;
